module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/features/tabination/tab-style1/tab-style1.component.scss
// module id = ./src/app/features/tabination/tab-style1/tab-style1.component.scss
// module chunks = main